import { currency } from "../endpoints/currency.endpoints";
import $axios from "../http/accessor";

const CurrencyService = {
  getAllData: () => {
    return $axios.get(currency.get_all);
  },

  createOne: (data: FormData) => {
    return $axios.post(currency.create, data);
  },

  getById: (id: number) => {
    return $axios.get(currency.get_by_id(id));
  },

  deleteData: (id: number) => {
    return $axios.delete(currency.delete(id));
  },

  updateData: (id: number, data: FormData) => {
    return $axios.put(currency.edit(id), data);
  },
};

export default CurrencyService;
